/**
 * @description 产品详情页公共内容加载与注册
 */


/************************************** 第三方内容引入 ***********************************************/
import "angular";
import 'angular-sanitize';
import 'ng-quill';
import 'quill/dist/quill.snow.css';
import 'swiper';
import 'angularjs-slider';
import 'angularjs-slider/dist/rzslider.min.css';
import 'angularjs-slider/dist/rzslider.min.js';

/************************************** 样式文件(加载顺序不可改变) ***********************************************/


/************************************** Module ***********************************************/

// import { PageModule } from "../../../modules/main/anonymous-page.module";
import { productModule } from "../../../modules/product/product.module";
import { storeListModule } from "../../../components/store-list/store-list.module";
import { LoadingModule } from "../../../directives/qp-loading/qp-loading.module";
import { module_name as qpPictureLoading } from "../../../directives/qp-picture-loading/qp-picture-loading.module";
import { IModuleRegist } from "../../../pages/personal-center/module-regist";
import { PicturePdfToPng } from "@filters/format-filter";
import { name as accessor } from "@modules/accessor/accessor.module"
import { name as storage } from "@modules/storage/storage.module";

import { module_name as anonymousModule } from "@modules/basic/page/anonymous/anonymous-page.module";
import { PageModule_name as header } from '@modules/main/header/header.module';
import { moduleName as bindTpl } from '@directives/bind-tpl-directive/bind-tpl.module';
import { module_name as addStoreProductModalModule } from '@components/add-store-product-modal/add-store-product-modal.module';
import { module_name as storeProductSettingModule } from '@components/store-product-setting/store-product-setting.module';
import { module_name as qpMessageFadeindownModule } from "../../../qp-ui-bootstrap/message-fadeindown/index";
import { module_name as qpLazyImageModule } from "../../../qp-ui-bootstrap/qp-lazy-image/qp-lazy-image.module";
/************************************** Service ***********************************************/

import { UserManager } from '../../../modules/user/manager/user.manager';

/************************************** Controller ***********************************************/

// import { ProductHeaderController } from '../../../modules/main/header/product-header.controller';

import { HeaderController } from '../../../modules/main/header/header.controller';

import { NavDrawerController } from '../../../modules/main/header/nav-drawer.controller';

/************************************** Directive ***********************************************/
// import { bindTplRegister } from "@directives/bind-tpl-directive/bind-tpl.register";
import { qpTotopModule } from "../../../qp-ui-bootstrap/totop";
/************************************** Template ***********************************************/
import storeProductSetupTpl from "../../store-product/template/store-product.template.tpl";
import shippingMethodTpl from "../../../pages/basic/product/detail/delivery/shipping-method.tpl"
import countryShippingTpl from "../../../pages/basic/product/detail/delivery/country-shipping.tpl"
import estimatedDeliveryTpl from "../../../pages/basic/product/detail/delivery/estimated-delivery.tpl"
import deliveryTableTpl from "../../../pages/basic/product/detail/delivery/delivery-table.tpl"
// import deliveryMobileTableTpl from "../../../pages/basic/product/detail/delivery/delivery-moblie-table.tpl"
import priceListModalTpl from "./price-list-modal/price-list-modal.tpl";


/************************************** Component ***********************************************/
import { StoreProductTypeComponent } from "../../../components/store-product-type/store-product-type.component";

import { gridStoreSelectorRegister } from "@components/store-select-input/grid-store-selector/grid-store-selector.register";

/************************************** Rest Config ***********************************************/

import { RuntimeContext } from "../../../modules/main/runtime-context.service";
import { ProductDetailController } from "./product-detail.controller";





/************************************** 样式文件(加载顺序不可改变) ***********************************************/
import './style/product-detail.less';

import 'swiper/css/bundle';
import { CmsConfigRestServiceConfig } from '@modules/cms/rest/cms-config-rest.config';
import { RestfulAccessorProvider } from '@core/data-access/restful';
import { CmsConfigRestService } from '@modules/cms/rest/cms-config-rest.service';
import { ProductDetailObjectTree } from './product-detail-object-tree';
import { AnonymousRestService } from '@modules/user/rest/anonymous-user-rest-service';
import { AnonymousRestServiceConfig } from '@modules/user/rest/anonymous-rest.config';
import { PropertyModelRestService } from '@modules/property-model/rest/property-model-rest.service';
import { PropertyModelRestServiceConfig } from '@modules/property-model/rest/property-model-rest.config';
import { ProductRestService as oldProductRestService } from '@modules/product/rest/product-rest.service';
import { ProductsRestServiceConfig } from '@modules/product/rest/products-rest.service.config';
import { ProductRestService as ProductV2RestService } from '@modules/product/rest/products-rest.service';
import { ProductPricingRestServiceConfig } from '@modules/product/rest/pricing/product-pricing-rest.config';
import { ProductPricingRestService } from '@modules/product/rest/pricing/product-pricing-rest.service';
import { PartnerRestServiceConfig } from '@modules/user/rest/partner/partner-rest-service.config';
import { PartnerRestService } from '@modules/user/rest/partner/partner-rest-service.service';
import { PlatformRestServiceConfig } from "@modules/platform/rest/platform-rest.config";
import { PlatFormRestService } from "@modules/platform/rest/platform-rest.service";
import { StoresRestServiceConfig } from "@modules/store/stores/rest/stores-rest.config";
import { StoresRestService } from "@modules/store/stores/rest/stores-rest.service";
import { StoreProductRestServiceConfig } from "@modules/store/store-product/rest/store-product-rest.config";
import { StoreProductRestService } from "@modules/store/store-product/rest/store-product-rest.service";


import { FooterPageController } from '@modules/main/footer-page/footerPage.controller';
import { ProductCategoriesRestService } from "@modules/product/categories/rest/product-categories-rest.service";
import { ProductCategoriesRestServiceConfig } from "@modules/product/categories/rest/product-categories-rest.config";
import { ProductDetailManager } from "./product-detail.manager";
import { CountryRestService } from "@modules/user/rest/country/country-rest-service";
import { CountryRestServiceConfig } from '@modules/user/rest/country/country-rest-service.config';

import { ShippingRestService } from "@modules/shipping/rest/shipping-rest.service";
import { ShippingRestServiceConfig } from '@modules/shipping/rest/shipping-rest.config';
import { BuilderRestServiceConfig } from "@modules/main/rest/builder/builder-rest.config";
import { BuilderRestService } from "@modules/main/rest/builder/builder-rest.service";
import { UserCartRestServiceConfig } from "@modules/cart/rest/user-cart-rest-service.config";
import { CartRestService } from "@modules/cart/rest/cart-rest-service";

import { restRuntime } from "@modules/main/rest-runtime.value";
import { StoreProductV2RestService } from "@modules/store/store-product-v2/rest/store-product-v2-rest.service";
import { StoreProductV2RestServiceConfig } from "@modules/store/store-product-v2/rest/store-product-v2-rest.config";
import { UserDataService } from "@modules/user/service/data/user-data-service";
import { DesignMethodRestService } from "@modules/product/design-method/design-method-rest.service";
import { DesignMethodRestConfig } from "@modules/product/design-method/design-method-rest.config";
import { loginComponentRegister } from "@pages/personal-center/builtin/product-design/fix-design-builtin/component/login/login.component.register";
import { DiscretePriceListComponent } from "@components/discrete-price-list/discrete-price-list.component";
import { ImageSize } from "@filters/image-size";
import { PurchaseTrackingService } from "@modules/payment/service/purchase-tracking.service";

let productDetailModuleName = "product-detail-base";

/************************************** 内容注册 ***********************************************/

let ProductDtailModule = angular.module(productDetailModuleName, ["ngQuill", anonymousModule, storeListModule.name, LoadingModule.name, qpPictureLoading, accessor, storage, header, bindTpl, qpTotopModule.name, addStoreProductModalModule, storeProductSettingModule, qpMessageFadeindownModule, qpLazyImageModule, "rzSlider"])

ProductDtailModule
    .controller({
        detailController: ProductDetailController,
        headerController: HeaderController,
        navDrawerController: NavDrawerController,
        footerPageController: FooterPageController
    })
    .service({
        storeProductRestService: StoreProductRestService,
        runtimeContext: RuntimeContext,
        userManager: UserManager,
        cmsConfigRestService: CmsConfigRestService,
        $objectTree: ProductDetailObjectTree,
        anonymousRestService: AnonymousRestService,
        propertyModelRestService: PropertyModelRestService,
        productV2RestService: ProductV2RestService,
        productRestService: oldProductRestService,
        productPricingRestService: ProductPricingRestService,
        partnerRestService: PartnerRestService,
        platFormRestService: PlatFormRestService,
        storesRestService: StoresRestService,
        builderRestService: BuilderRestService,
        productCategoriesRestService: ProductCategoriesRestService,
        productDetailManager: ProductDetailManager,
        countryRestService: CountryRestService,
        shippingRestService: ShippingRestService,
        cartRestService: CartRestService,
        storeProductV2RestService: StoreProductV2RestService,
        userDataService: UserDataService,
        designMethodRestService: DesignMethodRestService,
        purchaseTrackingService: PurchaseTrackingService
    })
    .component({
        storeProductTypeComponent: new StoreProductTypeComponent()
    })
    .constant("pageContext", {
        rootPath: "../../"
    })
    .filter({
        imageSize: ImageSize,
        picturePdfToPng: PicturePdfToPng
    })
    .constant("restRuntime", restRuntime)
    .constant("rootPath", "../../")
    .config(["$accessorProvider", function ($accessorProvider: RestfulAccessorProvider) {
        $accessorProvider.config(CmsConfigRestServiceConfig);
        $accessorProvider.config(AnonymousRestServiceConfig);
        $accessorProvider.config(PropertyModelRestServiceConfig);
        $accessorProvider.config(ProductsRestServiceConfig);
        $accessorProvider.config(ProductPricingRestServiceConfig);
        $accessorProvider.config(PartnerRestServiceConfig);
        $accessorProvider.config(PlatformRestServiceConfig);
        $accessorProvider.config(StoresRestServiceConfig);
        $accessorProvider.config(StoreProductRestServiceConfig);
        $accessorProvider.config(BuilderRestServiceConfig);
        $accessorProvider.config(ProductCategoriesRestServiceConfig);
        $accessorProvider.config(CountryRestServiceConfig);
        $accessorProvider.config(ShippingRestServiceConfig);
        $accessorProvider.config(UserCartRestServiceConfig);
        $accessorProvider.config(StoreProductV2RestServiceConfig);
        $accessorProvider.config(DesignMethodRestConfig);
    }])
    .run(["$templateCache", function ($templateCache) {
        $templateCache.put("store-product-steup.template.html", storeProductSetupTpl);
        $templateCache.put("shipping-method.template", shippingMethodTpl);
        $templateCache.put("country-shipping.template", countryShippingTpl);
        $templateCache.put("estimated-delivery.template", estimatedDeliveryTpl);
        $templateCache.put("delivery-table.template", deliveryTableTpl);
        // $templateCache.put("delivery-mobile-table.template", deliveryMobileTableTpl);
        $templateCache.put("price-list-modal.template", priceListModalTpl);
    }])
    .run(["$document", function ($document) {
        let oi = new IntersectionObserver((entries, self) => {
            entries.forEach(item => {
                if (item.isIntersecting) {
                    angular.element($document[0].querySelector('#startDesign')).removeClass("start-design__hide");
                    angular.element($document[0].querySelector('#startDesign')).addClass("start-design__show");
                } else {
                    if (window.scrollY == 0 || window.scrollY < 100) {
                        // 产品名称区域不在可视窗口内 且 window.scrollY=0,不显示底部导航
                        angular.element($document[0].querySelector('#startDesign')).removeClass("start-design__show");
                        angular.element($document[0].querySelector('#startDesign')).addClass("start-design__hide");
                    } else {
                        // 产品名称区域不在可视窗口内 且 window.scrollY>0,显示底部导航
                        angular.element($document[0].querySelector('#startDesign')).removeClass("start-design__hide");
                        angular.element($document[0].querySelector('#startDesign')).addClass("start-design__show");
                    }
                }
            })
        }, { threshold: [0] });
        // 产品名称区域DOM元素
        let productNameArea = document.getElementById("productName");
        if (!productNameArea) {
            return;
        }
        oi.observe(productNameArea);
    }])
gridStoreSelectorRegister.regist(ProductDtailModule);
loginComponentRegister.regist(ProductDtailModule);
export { productDetailModuleName };

// bindTplRegister.regist(ProductDtailModule as IModuleRegist);